module.exports = __webpack_public_path__ + "img/cream-uppercut-mattpomade-100.31bc0f92.jpg";